export default {"src":"/_next/static/media/book-and-pay.82e4cb68.svg","height":320,"width":320,"blurWidth":0,"blurHeight":0};